module.exports = {"id":"181120","name":"Chong Te Se","rating":"72","photo":"./data/images/photos/2/181120.png","club":{"name":"Shimizu","logo":"./data/images/clubs/Shimizu.png"},"positions":["BU"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ChongTeSe0.json
// module id = 776
// module chunks = 0